import { object, string } from 'yup';

import client from '$app-web/core/client';

const requestSchema = object().shape({
    email: string().email().required(),
});

const useSendForgotPasswordLinkToEmailEndpoint = client.registerEndpoint(
    'POST api/send-forgot-password-link-to-email',
    'v1/auth/reset_password/',
    {
        mutate: true,
        requestSchema,
    }
);

export default useSendForgotPasswordLinkToEmailEndpoint;
